import { selectRouterPathname } from '@noths/polaris-client-next-redux';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { replace } from 'connected-next-router';

import { adaptStoreToPageURL } from 'src/adapters/storeToPageQueryString/adaptStoreToPageURL';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';

export const updatePageURLWithQuery = createAsyncThunk(
  'products/updatePageURLWithQuery',
  async (_, { dispatch, getState }) => {
    const state = getState() as ReduxApplicationState;
    const { pathname } = state.router.location;
    const { page } = state.productsQuery;
    const urlParams = adaptStoreToPageURL(state, page);
    const query = urlParams.toString();
    const hash = state.navigation.hash ?? '';
    const as = query ? `${pathname}?${query}${hash}` : `${pathname}${hash}`;

    dispatch(
      replace(
        {
          pathname: selectRouterPathname(state),
          query,
        },
        as,
        { shallow: true, scroll: false },
      ),
    );
  },
);
